import { CUSTOMER_ROLES } from '@/constants/roles';

export default [
  {
    path: '/pages/profile',
    name: 'pages-profile',
    component: () => import('@/views/pages/profile/Profile.vue'),
    meta: {
      pageTitle: 'Profile',
      breadcrumb: {
        label: 'Profile'
      }
    }
  },
  {
    path: '/pages/user-create',
    name: 'pages-user-create',
    component: () => import('@/views/pages/profile/UserCreate.vue'),
    meta: {
      pageTitle: 'Create User',
      breadcrumb: {
        label: 'Create User'
      },
      roles: CUSTOMER_ROLES
    }
  }
];
